var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "a",
    {
      staticClass: "cw-unit-progress-item",
      attrs: {
        href: "#",
        title: _vm.name,
      },
      on: {
        click: function click($event) {
          return _vm.$emit("selectChapter", _vm.chapterId)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-unit-progress-item-value",
        },
        [
          _c("courseware-progress-circle", {
            attrs: {
              value: parseInt(_vm.value),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-unit-progress-item-description",
        },
        [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }